import request from '@/utils/request'

/**
 * 进口核查证列表
 * @param {*} data 
 * @returns 
 */
export const getJKHCList = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkhcz/list`,
    data: data
})

/**
 * 新增进口核查证
 * @param {*} data 
 * @returns 
 */
export const addJKHC = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkhcz/add`,
    data: data
})

/**
 * 查询进口核查证
 * @param {*} id 
 * @returns 
 */
export const getJKHC = (id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/jkhcz/detail/${id}`
})


/**
 * 编辑进口核查证
 * @param {*} data 
 * @returns 
 */
export const updateJKHC = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkhcz/edit`,
    data
})

/**
 * 删除进口核查证
 * @param {*} id 
 * @returns 
 */
export const deleteJKHC = (id) => request({
    method: 'delete',
    url: `/yzdservice/api/enterprise/jkhcz/delete/${id}`
})
/**
 * 删除进口核查证图片
 * @param {*} id 
 * @returns 
 */
export const deleteJKHCImage = (id) => request({
    method: 'delete',
    url: `/yzdservice/api/enterprise/jkhcz/deletefile/${id}`
})

/**
 * 核销进口核查证
 * @param {*} id 
 * @returns 
 */
export const writeOffJKHC = (id) => request({
    method: 'put',
    url: `/yzdservice/api/enterprise/jkhcz/WriteOff/${id}`
})
/**
 * 取消核销进口核查证
 * @param {*} data 
 * @returns 
 */
export const cancelWriteOffJKHC = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkhcz/cancelWriteOff`,
    data
})

/**
 * 证书审批详情
 * @param {*} id 
 * @returns 
 */
export const getCredentials = (id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/credentials/common/splc/${id}`
})

/**
 * 导出
 * @param {*} data 
 * @returns 
 */
export const excelwriter = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkhcz/excelwriter`,
    data,
    responseType: 'blob'
})

/**
 * 获取国家下拉
 * @param {*} id 
 * @returns 
 */
 export const getCountry = () => request({
    method: 'get',
    url: `/yzdservice/api/jck/base/country/tree`
})

/**
 * 获取进口港下拉
 * @param {*} id 
 * @returns 
 */
 export const getPort = () => request({
    method: 'get',
    url: `/yzdservice/api/jck/base/port/tree`
})

/**
 * 手动录入 本系统
 * @param {*} data
 * @returns 
 */
 export const manualEntry = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkhcz/recordTo`,
    data
})

/**
 * 手动录入 外系统
 * @param {*} data
 * @returns 
 */
 export const manualEntry2 = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkhcz/record`,
    data
})



/**
 * 进口核查证列表
 * @param {*} data 
 * @returns 
 */
 export const getJKHCList2 = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/jkhcz/recordList`,
    data: data
})

/**
 * 查询进口核查证 外部
 * @param {*} id 
 * @returns 
 */
 export const getJKHC2 = (id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/jkhcz/inputdetail/${id}`
})